<template>
  <div class="dock-five-six w100 flex flex-dir--top h100">
    <breadcrumb
      :title="$route.query.line || $t('main.head.produceLine')"
      :childTitle="$t('common.dock56FDrill')"
      @goBackPage="goBackPage"
    >
      <div v-if="!previewInfo.isPreview">
        <a-button
          @click.native="handleOpenChangeRecord"
          id="equipment_five_six_change_record"
          class="mr20"
        >
          修改记录
        </a-button>
        <a-button
          @click.native="saveDockFiveSix"
          :disabled="!ableSaveSetting"
          type="primary"
          id="equipment_setting_save_btn"
          ><a-icon type="save" />{{ $t('common.saveSetting') }}</a-button
        >
      </div>
      <div v-if="previewInfo.isApply">
        <a-button
          @click.native="saveDockFiveSix"
          :disabled="!ableSaveSetting"
          type="primary"
          id="equipment_setting_save_btn"
          ><a-icon type="save" />应用设置</a-button
        >
      </div>
    </breadcrumb>
    <div class="wrap pb20 pt20 h100 y-auto">
      <div class="equip-type">
        <span id="span_o6oslnvdwi" class="head-title">{{
          $t('dock56Drill.equipType')
        }}</span>
        <div class="content">
          <!-- <span class="small-title">设备类型：</span> -->
          <a-radio-group v-model="dockType" :disabled="dock56FDrill_customFile">
            <a-radio value="fiveDock" id="fiveSix_setting_five_radio"
              ><span id="fiveSix_setting_five_radio_label">{{
                $t('dock56Drill.fiveDock')
              }}</span></a-radio
            >
            <a-radio value="sixDock" id="fiveSix_setting_six_radio"
              ><span id="fiveSix_setting_six_radio_label">{{
                $t('dock56Drill.sixDock')
              }}</span></a-radio
            >
          </a-radio-group>
        </div>
      </div>
      <div>
        <div class="file-format">
          <span id="span_bcn1udjhon" class="head-title">{{
            $t('dock56Drill.fileType')
          }}</span>
          <div class="content flex">
            <div class="relative">
              <span id="span_qfcd8wscc2" class="small-title"
                >{{ $t('dock56Drill.fileType') }}：</span
              >
              <a-select
                :disabled="dock56FDrill_customFile"
                style="width: 330px"
                :getPopupContainer="
                  (triggerNode) => {
                    return triggerNode.parentNode || document.body
                  }
                "
                :filter-option="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .trim()
                      .includes(input.toLowerCase())
                "
                show-search
                default-value="xml"
                v-model="selectedDockFile"
                showArrow
                @change="changeSelectedDockFile"
                id="fiveSix_setting_dockFile_select"
              >
                <a-select-option
                  :value="item.dock56Format"
                  v-for="(item, index) in dockFiveSixList"
                  :key="index"
                  :title="item.modelName"
                  :id="`fiveSix_setting_dockFile_select_option_${index}`"
                  >{{ item.modelName }}</a-select-option
                >
              </a-select>
              <span
                id="span_7w84yfqfjv"
                v-if="isNotOnline"
                class="not-online"
                >{{ $t('dock56Drill.templateOffline') }}</span
              >
              <div
                id="div_4pv2979w8i"
                v-if="showFiveSixDefault"
                class="tip mt8"
              >
                当前模板对于部分孔槽分流功能不生效，推荐使用自定义模板
              </div>
              <div class="mt20">
                <span id="span_re3ttm70vl" class="small-title"
                  >{{ $t('dock56Drill.showExample') }}：</span
                >
                <a-checkbox
                  v-model="showSample"
                  id="fiveSix_setting_showSample_checkbox"
                  v-bp:change="'dock56f:showSample'"
                ></a-checkbox>
              </div>
            </div>
            <div class="remark-info flex flex-dir--top ml20 fs14">
              <span id="span_e3xbi3vvn1" class="note">{{
                $t('dock56Drill.conNoticeTip')
              }}</span>
              <span id="span_fr3xu22kks">{{
                $t('dock56Drill.conNoticeTip1')
              }}</span>
              <span id="span_7bxp87k95z">{{
                $t('dock56Drill.conNoticeTip2')
              }}</span>
              <span v-html="$t('dock56Drill.conNoticeTip3')"></span>
              <span v-html="$t('dock56Drill.conNoticeTip4')"></span>
            </div>
          </div>
        </div>
        <div class="common-setting" v-show="showSample">
          <span id="span_a2ss4v247m" class="head-title">{{
            $t('dock56Drill.example')
          }}</span>
          <div class="content">
            <DockFiveSixSample :file-type="selectedDockFile" />
          </div>
        </div>
        <div class="common-setting">
          <span id="span_1sl9vukru9" class="head-title">{{
            $t('dock56Drill.commonSetting')
          }}</span>
          <div class="content">
            <span id="span_m2d8crzflx" class="small-title"
              >{{ $t('dock56Drill.throughHoleSetting') }}：</span
            >
            <a-checkbox
              v-model="dock6FDrill_towSideConHole"
              id="fiveSix_setting_towSideConHole_checkbox"
            ></a-checkbox>
          </div>
          <div class="content">
            <span id="span_7rfrpnsyke" class="small-title"
              >{{ $t('dock56Drill.throughSlotSetting') }}：</span
            >
            <a-checkbox
              v-model="dock56FDrill_twoSideConSlot"
              id="fiveSix_setting_towSideConSlot_checkbox"
            ></a-checkbox>
          </div>
          <div class="content">
            <span id="span_bmmrgbz3v0" class="small-title">{{
              $t('dock56Drill.nonHolesNotFiles')
            }}</span>
            <a-checkbox
              v-model="non_holes_not_files"
              id="fiveSix_setting_non_holes_not_files_checkbox"
            ></a-checkbox>
          </div>
          <div class="content front-back-symbol">
            <span id="span_1vav1vi0z2" class="small-title"
              >{{ $translateLang('正反面文件标识功能已迁移至')
              }}<span
                id="span_qp1l22gwzk"
                class="link"
                @click="handleOpenFileManage"
                >{{ $translateLang('文件管理') }}</span
              ></span
            >
          </div>
          <div class="content">
            <span id="span_crb71w14xz" class="small-title"
              >{{ $t('dock56Drill.arcDescription') }}：</span
            >
            <a-radio-group v-model="arc_description">
              <a-radio
                value="line_points"
                id="fiveSix_setting_arc_description_line_points_radio"
                ><span
                  id="fiveSix_setting_arc_description_line_points_radio_label"
                  >{{ $t('dock56Drill.linePoints') }}</span
                ></a-radio
              >
              <a-radio
                value="arc_command"
                id="fiveSix_setting_arc_description_arc_command_radio"
                ><span
                  id="fiveSix_setting_arc_description_arc_command_radio_label"
                  >{{ $t('dock56Drill.arcCommand') }}</span
                ></a-radio
              >
            </a-radio-group>
          </div>
          <div class="content">
            <span id="span_j0gpeywor5" class="small-title">{{
              $t('dock56Drill.slotWidthSplit')
            }}</span>
            <a-checkbox
              v-model="split_slot"
              id="fiveSix_setting_split_slot_checkbox"
            ></a-checkbox>
            <span id="span_p3p4mpy98w" class="small-title partition">{{
              $t('dock56Drill.slotSplitWidth')
            }}</span>
            <a-input
              v-model="single_width"
              @change="changeSingleWidth(single_width)"
              id="fiveSix_setting_single_width_input"
            ></a-input>
            <span id="span_1kwla7foly" class="partition hintColor">{{
              $t('dock56Drill.mm')
            }}</span>
            <img
              :src="require('@/assets/banlu_dismantle.png')"
              alt="无法加载"
              class="partition"
            />
          </div>
          <div class="content flex flex-cross--center">
            <span id="span_hqas665kim" class="small-title">{{
              $t('dock56Drill.isNotMergeSlot')
            }}</span>
            <a-checkbox
              v-model="isNotMergeSlot"
              id="dockFiveSix_isNotMergeSlot_checkbox"
            ></a-checkbox>
            <img
              src="https://cdn.eggrj.com/bluenAssets/image/dockFiveSix_slotPunch.png"
              alt="无法加载"
              class="slot-tuglie ml15"
            />
            <span id="span_0yrxe9o59a" class="ml15"
              >({{ $t('dock56Drill.slotPunchTip') }})</span
            >
          </div>
          <transition name="adjacent-size-transition">
            <div class="content" v-if="isNotMergeSlot">
              <span id="span_7xdrjtgb88" class="small-title">{{
                $t('dock56Drill.sizeRange')
              }}</span>
              <a-input
                id="dockFiveSix_adjacentSize_input"
                v-model="adjacentSize"
                style="margin: 0 4px"
                @change="handleChangeAdjacentSize(adjacentSize)"
              ></a-input>
              <span>mm</span>
            </div>
          </transition>

          <div class="content-container" @click="handleClickContentContainer">
            <!-- 内部异形切割下刀和收刀 -->
            <div class="content">
              <span id="span_c2y0cc6z87" class="small-title"
                >{{
                  $translateLang('内部异形切割下刀和收刀均在板件内侧')
                }}：</span
              >
              <a-checkbox
                v-model="internal_cut_inside"
                id="fiveSix_setting_internal_cut_inside_checkbox"
              ></a-checkbox>
            </div>
            <!-- 外部异形切割下刀和收刀 -->
            <div class="content">
              <span id="span_nhobx9r601" class="small-title"
                >{{
                  $translateLang('外部异形切割下刀和收刀均在板件外侧')
                }}：</span
              >
              <a-checkbox
                v-model="external_cut_outside"
                id="fiveSix_setting_externalCutting_checkbox"
              ></a-checkbox>
            </div>
            <!-- 外部异形切割时，包含异形的整条边缘将同步切割 -->
            <div class="content">
              <span id="span_b5nz7kp5tu" class="small-title"
                >{{
                  $translateLang(
                    '外部异形切割时，包含异形的整条边缘将同步切割'
                  )
                }}：</span
              >
              <a-checkbox
                v-model="cut_path_extension"
                id="fiveSix_setting_cut_path_extension_checkbox"
                class="fiveSix_externalCutting_checkbox"
              ></a-checkbox>

              <a-radio-group v-model="cut_path_extension_mode">
                <a-radio
                  value="all"
                  id="fiveSix_setting_cut_path_extension_radio_1"
                  >{{ $translateLang('所有外异形') }}</a-radio
                >
                <a-radio
                  value="arc"
                  id="fiveSix_setting_cut_path_extension_radio_2"
                  >{{ $translateLang('仅外圆弧异形') }}</a-radio
                >
              </a-radio-group>
            </div>
          </div>

          <!-- 板件摆放方式： -->
          <div class="content">
            <span id="span_oue9341swq" class="small-title"
              >{{ $translateLang('板件摆放方式') }}：</span
            >
            <a-radio-group
              v-model="plankPlacement"
              @change="handlePlankPlacement"
              class="mr0"
            >
              <a-radio
                :value="1"
                id="fiveSix_setting_output56FDrillSlotDir_default_radio"
                >{{ $translateLang('自动避让夹手') }}</a-radio
              >
              <a-radio
                :value="2"
                id="fiveSix_setting_output56FDrillSlotDir_frontLeft_radio"
                >{{ $translateLang('手动设置避让') }}</a-radio
              >
              <a-radio
                :value="3"
                id="fiveSix_setting_output56FDrillSlotDir_frontRight_radio"
                >{{ $translateLang('固定前封边') }}
                <span id="span_fff5lb9spy" class="tip"
                  >({{ $translateLang('仅对云排版生效') }})</span
                ></a-radio
              >
              <a-radio
                :value="4"
                id="fiveSix_setting_output56FDrillSlotDir_fixedEdge_radio"
                >{{ $translateLang('固定长封边靠夹手边') }}
                <span id="span_fff5lb9spy" class="tip mr2"
                  >({{ $translateLang('仅对云排版生效') }})</span
                >
                <template>
                  <a-tooltip overlay-class-name="fixture-placement-tip">
                    <template slot="title">
                      <div class="fixture-placement-tip__content">
                        <p class="fixture-placement-tip__title">
                          {{ $translateLang('规则说明：判断板件摆放情况') }}
                        </p>
                        <p>{{ $translateLang('优先级顺序') }}</p>
                        <p>
                          {{ $translateLang('满足条件') }}1：{{
                            $translateLang('长边靠夹手')
                          }}
                        </p>
                        <p>
                          {{ $translateLang('满足条件') }}2：{{
                            $translateLang('封边靠夹手')
                          }}
                        </p>
                        <p>
                          {{ $translateLang('满足条件') }}3：{{
                            $translateLang('孔槽避让')
                          }}
                        </p>
                      </div>
                    </template>
                    <a-icon type="question-circle" />
                  </a-tooltip> </template
              ></a-radio>
            </a-radio-group>
            <span
              >（{{
                $translateLang(
                  '若当前生产线开启桦桦自动线则不支持单独设置板件摆放方式'
                )
              }}）</span
            >
          </div>

          <!-- 自动夹手避让 -->
          <div
            class="content content-level"
            v-if="plankPlacement === 1 || plankPlacement === 4"
          >
            <span id="span_bsqbcafk2n" class="small-title">
              {{ $translateLang('夹手所在方向') }}：
            </span>
            <a-radio-group v-model="fixtureSetting.fixtureDirection">
              <a-radio
                value="front"
                id="fiveSix_setting_automationLine_front_radio"
                >{{ $translateLang('前侧') }}</a-radio
              >
              <a-radio
                value="back"
                id="fiveSix_setting_automationLine_back_radio"
                >{{ $translateLang('后侧') }}</a-radio
              >
              <a-radio
                value="left"
                id="fiveSix_setting_automationLine_left_radio"
                >{{ $translateLang('左侧') }}</a-radio
              >
              <a-radio
                value="right"
                id="fiveSix_setting_automationLine_right_radio"
                >{{ $translateLang('右侧')
                }}<span id="span_ski5lr5knh"
                  >({{
                    $translateLang(
                      '通过旋转的方式让孔槽和异形自动避让夹手所在侧，便于板件加工'
                    )
                  }})</span
                ></a-radio
              >
            </a-radio-group>
          </div>
          <div
            class="flex content content-level"
            v-if="plankPlacement === 1 || plankPlacement === 4"
          >
            <div class="content-left">
              <!-- 夹手宽度 -->
              <div class="mb10">
                <span id="span_t6r8uns4ea" class="small-title mr10"
                  >{{ $translateLang('夹手宽度') }}(W)：</span
                >
                <a-input
                  v-model="fixtureSetting.fixtureWidth"
                  id="fiveSix_setting_fixtureWidth_input"
                  @input="
                    verifyInputNumber(
                      fixtureSetting.fixtureWidth,
                      fixtureSetting,
                      ['fixtureWidth'],
                      '4-2',
                      false,
                      '',
                      false
                    )
                  "
                >
                </a-input>
              </div>
              <!-- 夹手宽度 -->
              <div class="mb10">
                <span id="span_xy7swahplg" class="small-title mr10"
                  >{{ $translateLang('夹手长度') }}(H)：</span
                >
                <a-input
                  v-model="fixtureSetting.fixtureLength"
                  id="fiveSix_setting_fixtureLength_input"
                  @input="
                    verifyInputNumber(
                      fixtureSetting.fixtureLength,
                      fixtureSetting,
                      ['fixtureLength'],
                      '4-2',
                      false,
                      '',
                      false
                    )
                  "
                >
                </a-input>
              </div>
              <!-- 设备可加工最大宽度 -->
              <div>
                <span id="span_9k2vpfaycl" class="small-title mr10"
                  >{{ $translateLang('设备可加工的最大宽度') }}：</span
                >
                <a-input
                  v-model="fixtureSetting.machineMaxWidth"
                  id="fiveSix_setting_machineMaxWidth_input"
                  @input="
                    verifyInputNumber(
                      fixtureSetting.machineMaxWidth,
                      fixtureSetting,
                      ['machineMaxWidth'],
                      '4-2',
                      false,
                      '',
                      false
                    )
                  "
                >
                </a-input>
              </div>
            </div>
            <div class="content-right">
              <img
                v-if="fixtureSetting.fixtureDirection === 'front'"
                src="../../assets/fiveSixSet/handleCursorBottom.png"
                alt=""
              />
              <img
                v-if="fixtureSetting.fixtureDirection === 'back'"
                src="../../assets/fiveSixSet/handleCursorTop.png"
                alt=""
              />
              <img
                v-if="fixtureSetting.fixtureDirection === 'right'"
                src="../../assets/fiveSixSet/handleCursorRight.png"
                alt=""
              />
              <img
                v-if="fixtureSetting.fixtureDirection === 'left'"
                src="../../assets/fiveSixSet/handleCursorLeft.png"
                alt=""
              />
            </div>
          </div>

          <!-- 手动设置避让 -->
          <el-tooltip
            :disabled="!is_front_edge_fixed"
            v-if="plankPlacement === 2"
            :content="$t('dock56Drill.enableWorningTip')"
            placement="top"
          >
            <div class="content content-level">
              <span id="span_ocxlpw3c8t" class="small-title">{{
                $t('dock56Drill.longDirection')
              }}</span>
              <a-checkbox
                :disabled="is_front_edge_fixed"
                class="check"
                v-model="is_output56FDrillLayoutDir"
                id="fiveSix_setting_direction_check"
              ></a-checkbox>
              <a-radio-group
                v-model="output56FDrillLayoutDir"
                :disabled="is_front_edge_fixed || !is_output56FDrillLayoutDir"
              >
                <a-radio
                  value="Horizontal"
                  id="fiveSix_setting_horizontal_radio"
                  >{{ $t('dock56Drill.horizontal') }}</a-radio
                >
                <a-radio value="Vertical" id="fiveSix_setting_vertical_radio">{{
                  $t('dock56Drill.vertical')
                }}</a-radio>
              </a-radio-group>
            </div>
          </el-tooltip>
          <el-tooltip
            :disabled="!is_front_edge_fixed"
            v-if="plankPlacement === 2"
            :content="$t('dock56Drill.enableWorningTip')"
            placement="top"
          >
            <div class="content shape-texdir content-level">
              <span id="span_bqf86a243d" class="small-title">{{
                $t('dock56Drill.slotDirection')
              }}</span>
              <a-checkbox
                :disabled="is_front_edge_fixed"
                class="check"
                v-model="selectedOutput56DrillSoltDir"
                id="fiveSix_setting_horizontal_radio"
              ></a-checkbox>
              <a-radio-group
                v-model="output56FDrillSlotDir"
                :disabled="!selectedOutput56DrillSoltDir || is_front_edge_fixed"
              >
                <a-radio
                  value="default"
                  id="fiveSix_setting_output56FDrillSlotDir_default_radio"
                  >{{ $t('dock56Drill.default') }}</a-radio
                >
                <a-radio
                  value="frontLeft"
                  id="fiveSix_setting_output56FDrillSlotDir_frontLeft_radio"
                  >{{ $t('dock56Drill.frontLeft') }}</a-radio
                >
                <a-radio
                  value="frontRight"
                  id="fiveSix_setting_output56FDrillSlotDir_frontRight_radio"
                  >{{ $t('dock56Drill.frontRight') }}</a-radio
                >
                <a-radio
                  value="backLeft"
                  id="fiveSix_setting_output56FDrillSlotDir_backLeft_radio"
                  >{{ $t('dock56Drill.backLeft') }}</a-radio
                >
                <a-radio
                  value="backRight"
                  id="fiveSix_setting_output56FDrillSlotDir_backRight_radio"
                  >{{ $t('dock56Drill.backRight') }}</a-radio
                >
              </a-radio-group>
              <div class="drill-slot-dir">
                <img
                  :src="require('@/assets/output56FDrillSlotDir.png')"
                  alt=""
                />
              </div>
              <!-- 生效范围 -->
              <div>
                <span id="span_zmbodzetvs" class="mr10"
                  >生效范围：板件长边≤</span
                >
                <a-input
                  :value="long_edge_rotate_range"
                  :disabled="
                    is_front_edge_fixed || !selectedOutput56DrillSoltDir
                  "
                  id="fiveSix_setting_longEdgeRotateRange_input"
                  @input="handleInputCheck"
                ></a-input>
                <span id="span_pz28pu8d6n" class="ml15"
                  >(当开启板件长边摆放且板子长边在该生效范围内会优先判断槽和异形放置位置)</span
                >
              </div>
            </div>
          </el-tooltip>

          <!-- 跟随前封边摆放方向 -->
          <!-- 前封边摆放方向 -->
          <div class="content content-level" v-if="plankPlacement === 3">
            <div class="mt10">
              <span id="span_jv2thx3e4c" class="small-title">{{
                $t('dock56Drill.fixedOn')
              }}</span>
              <a-radio-group
                v-model="front_edge_fixed_direction"
                :disabled="!is_front_edge_fixed"
              >
                <a-radio value="front" id="fiveSix_setting_fixed_front_radio">{{
                  $t('dock56Drill.front')
                }}</a-radio>
                <a-radio value="back" id="fiveSix_setting_fixed_back_radio">{{
                  $t('dock56Drill.back')
                }}</a-radio>
                <a-radio value="left" id="fiveSix_setting_fixed_left_radio">{{
                  $t('dock56Drill.left')
                }}</a-radio>
                <a-radio value="right" id="fiveSix_setting_fixed_right_radio">{{
                  $t('dock56Drill.right')
                }}</a-radio>
              </a-radio-group>
            </div>
          </div>

          <div class="content">
            <span class="small-title"
              >{{ $translateLang('指定板件名摆放') }}
              <a-tooltip
                placement="top"
                overlay-class-name="plank-name-placement-tip"
              >
                <template #title>
                  <div class="plank-name-placement-tip__content">
                    <p>
                      {{
                        $translateLang(
                          '1、设置后，当板件名称中包含所设字段时，该板件将按对应设置固定对应边在设备的指定侧'
                        )
                      }}
                    </p>
                    <p>
                      {{
                        $translateLang(
                          '2、此处设置的优先级大于上方的板件摆放方式设置'
                        )
                      }}
                    </p>
                    <p>
                      {{
                        $translateLang(
                          '3、该功能仅对云排版生效，若当前生产线开启桦桦自动线则不支持单独设置板件摆放方式'
                        )
                      }}
                    </p>
                  </div>
                </template>
                <i class="iconfont icon-wenhao ml2"></i>
              </a-tooltip>
              ：
            </span>
            <a-checkbox
              v-model="plank_name_placement.is_open"
              id="fiveSix_setting_plankNamePlacementIsOpen_checkbox"
            ></a-checkbox>
          </div>
          <div
            class="content add-row"
            v-show="plank_name_placement.is_open"
            @click="handleAddRow"
          >
            {{ $translateLang('添加行') }}
          </div>
          <div class="content" v-show="plank_name_placement.is_open">
            <a-table
              bordered
              :columns="plankNameColumns"
              :data-source="plank_name_placement.rules"
              :pagination="false"
              :row-key="(record) => record.webId"
              style="width: 700px; min-height: 120px"
            >
              <template slot="plankName" slot-scope="text, record">
                <a-input
                  v-if="editingPlankNameId === record.webId"
                  :ref="`plankNameInput_${record.webId}`"
                  v-model="record.plank_name"
                  :maxLength="20"
                  :placeholder="$translateLang('请输入板件名')"
                  style="width: 100%"
                  @blur="handleBlurPlankNameCell"
                ></a-input>
                <div
                  v-else
                  class="plank-name-cell"
                  :class="{ 'is-placeholder': !record.plank_name }"
                  @click="handleEditPlankNameCell(record)"
                >
                  {{ record.plank_name || $translateLang('请输入板件名') }}
                </div>
              </template>
              <template slot="plankEdge" slot-scope="text, record">
                <a-select v-model="record.plank_edge" style="width: 100%">
                  <a-select-option
                    v-for="item in plankDirectionOptions"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ $translateLang(item.label) }}
                  </a-select-option>
                </a-select>
              </template>
              <template slot="deviceSide" slot-scope="text, record">
                <a-select v-model="record.device_side" style="width: 100%">
                  <a-select-option
                    v-for="item in deviceSideOptions"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ $translateLang(item.label) }}
                  </a-select-option>
                </a-select>
              </template>
              <template slot="operation" slot-scope="text, record, index">
                <span
                  class="plank-name-placement-del"
                  @click="handleDelRow(index)"
                >
                  {{ $translateLang('删除') }}
                </span>
              </template>
            </a-table>
          </div>

          <div class="content" v-show="sawPermission">
            <span class="small-title"
              >{{ $translateLang('焊接板原边固定靠夹手') }}：</span
            >
            <a-checkbox
              v-model="welding_plate_placement.enable"
              id="fiveSix_setting_weldingPlatePlacementEnable_checkbox"
            ></a-checkbox>
          </div>
          <div
            class="content"
            v-show="sawPermission && welding_plate_placement.enable"
          >
            <span class="small-title" style="padding-left: 34px"
              >{{ $translateLang('夹手所在方向') }}：</span
            >
            <a-radio-group v-model="welding_plate_placement.direction">
              <a-radio
                v-for="item in directionOptions"
                :key="item.value"
                :value="item.value"
                :id="`fiveSix_setting_weldingPlatePlacementDirection_${item.value}_radio`"
              >
                {{ $translateLang(item.label) }}
              </a-radio>
            </a-radio-group>
          </div>

          <!-- 小板标记 -->
          <div class="content part-mark-content">
            <span id="span_nmxx1pyj6u" class="small-title"
              >{{ $translateLang('小板标记') }}：</span
            >
            <div class="item">
              <span id="span_f0x6ltr9ac">{{ $translateLang('长边小于') }}</span>
              <a-input
                suffix="mm"
                v-model="smallPlankCondition.longSide"
                class="ml8 mr8"
                style="width: 100px"
                @input="
                  verifyInputNumber(
                    smallPlankCondition.longSide,
                    smallPlankCondition,
                    ['longSide'],
                    '5-2',
                    false,
                    '',
                    false
                  )
                "
              ></a-input>
              <span id="span_n13rtyek3v">{{
                $translateLang('或短边小于')
              }}</span>
              <a-input
                style="width: 100px"
                suffix="mm"
                v-model="smallPlankCondition.shortSide"
                class="ml8 mr8"
                @input="
                  verifyInputNumber(
                    smallPlankCondition.shortSide,
                    smallPlankCondition,
                    ['shortSide'],
                    '5-2',
                    false,
                    '',
                    false
                  )
                "
              ></a-input>
              <span id="span_kpwsnw9aj7">{{
                $translateLang('的板件生成小板标识')
              }}</span>
              <span id="span_ekpv49usjy" class="item-tip">{{
                $translateLang(
                  '（标签上展示需添加“板件标识-小板标记”数据，桦桦自动线文件中会自动添加对应数据）'
                )
              }}</span>
            </div>
          </div>
          <!-- 坐标值保留位数 -->
          <div class="content">
            <span id="span_eec8lcgmhl" class="small-title">{{
              $t('dock56Drill.coordinateValue')
            }}</span>
            <el-input
              v-model.number="output56FDrillDecimalNum"
              oninput="value=value.replace(/[^0-9]/g,'')"
              id="fiveSix_setting_output56FDrillDecimalNum_input"
            />
            <span id="span_lgehk1s6zl">{{
              $t('dock56Drill.decimalPlaces')
            }}</span>
          </div>
          <!-- 槽长度补偿 -->
          <div class="content slot-compensation-content">
            <span id="span_i13ob0ukul" class="small-title"
              >{{ $translateLang('槽长度补偿') }}：</span
            >
            <div>
              <div class="item">
                <span id="span_b0uiamkz5v"
                  >{{ $translateLang('距边为0的槽边补偿') }}:</span
                >
                <a-input
                  :value="slotEdge0Comp"
                  id="fiveSix_setting_slotEdge0Comp_input"
                  class="item-input"
                  suffix="mm"
                  @input="(e) => formatInputValue('slotEdge0Comp', e)"
                  @blur="handleBlurAddBurypoint('slotEdge0Comp')"
                >
                </a-input>
                <span id="span_nv5otqwb9s"
                  >({{
                    $translateLang(
                      '加工出现未切干净的小圆角或长度不够时使用此功能'
                    )
                  }})</span
                >
              </div>
              <div class="item">
                <span id="span_tixf0cblaq"
                  >{{ $translateLang('距边不为0的槽边补偿') }}:</span
                >
                <a-input
                  :value="slotNoEdge0Comp"
                  id="fiveSix_setting_slotNoEdge0Comp_input"
                  class="item-input"
                  suffix="mm"
                  @input="(e) => formatInputValue('slotNoEdge0Comp', e)"
                  @blur="handleBlurAddBurypoint('slotNoEdge0Comp')"
                ></a-input>
              </div>
            </div>
          </div>
          <!-- 内部异形清角 -->
          <div class="content slot-compensation-content">
            <span id="span_i13ob0ukul" class="small-title"
              >{{ $translateLang('内部异形清角') }}：</span
            >
            <div class="item">
              <span id="span_b0uiamkz5v"
                >{{ $translateLang('距边为0的内部异形边补偿') }}:</span
              >
              <a-input
                :value="inner_shape_compensation_by_margin_le_0"
                id="fiveSix_setting_slotEdge0Comp_input"
                class="item-input"
                suffix="mm"
                @input="
                  (e) =>
                    formatInputValue(
                      'inner_shape_compensation_by_margin_le_0',
                      e
                    )
                "
                @blur="
                  handleBlurAddBurypoint(
                    'inner_shape_compensation_by_margin_le_0'
                  )
                "
              >
              </a-input>
              <div>
                <div id="span_nv5otqwb9s" class="mt6">
                  ({{ $translateLang('建议输入：铣内部异形刀具的半径值') }})
                </div>
                <div id="span_nv5otqwb9s" class="mt6">
                  ({{
                    $translateLang(
                      '在板件轮廓外接矩形边加工的内部异形出现未切干净的小圆角时使用此功能'
                    )
                  }})
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="common-setting">
          <span id="span_6oqck4nii2" class="head-title">{{
            $translateLang('刀库')
          }}</span>
          <div class="main-table" id="five-six-knives-table">
            <el-table
              :data="knives"
              :row-style="changeStyle"
              :header-cell-style="headerStyle"
              :header-row-style="headerRowStyle"
              @row-click="choseKnife"
              :row-class-name="tableRowClassName"
              :cell-class-name="tableCellClassName"
              @cell-click="cellClick"
              :max-height="340"
              style="width: 760px"
            >
              <el-table-column
                v-for="(knife, indexs) in knivesColumns"
                :key="indexs + '1'"
                :label="$translateLang(knife.label)"
                :prop="knife.props"
                :width="knife.width"
                :fixed="[0, 1, 2, 3].includes(indexs)"
              >
                <template slot-scope="scope">
                  <div v-if="knife.props === 'use'" class="knife-purpose">
                    <a-checkbox-group v-model="scope.row.knifePurpose">
                      <a-checkbox
                        value="milling_outer"
                        :id="`five_six_setting_knife_table_${scope.row.index}_use_milling_outer_checkbox`"
                        @change="
                          onlyOneChecked($event, scope.row, 'milling_outer')
                        "
                      >
                        <span
                          style="margin: 0"
                          :id="`five_six_setting_knife_table_${scope.row.index}_use_milling_outer_checkbox_label`"
                          >{{ $translateLang('铣外异形') }}</span
                        >
                      </a-checkbox>
                      <a-checkbox
                        value="milling_inner"
                        :id="`five_six_setting_knife_table_${scope.row.index}_use_milling_inner_checkbox`"
                        @change="
                          onlyOneChecked($event, scope.row, 'milling_inner')
                        "
                      >
                        <span
                          style="margin: 0"
                          :id="`five_six_setting_knife_table_${scope.row.index}_use_milling_inner_checkbox_label`"
                          >{{ $translateLang('铣内异形') }}</span
                        >
                      </a-checkbox>
                      <a-checkbox
                        value="drilling"
                        :id="`five_six_setting_knife_table_${scope.row.index}_use_drilling_checkbox`"
                      >
                        <span
                          style="margin: 0"
                          :id="`five_six_setting_knife_table_${scope.row.index}_use_drilling_checkbox_label`"
                          >{{ $translateLang('加工孔') }}</span
                        >
                      </a-checkbox>
                      <a-checkbox
                        value="slotting"
                        :id="`five_six_setting_knife_table_${scope.row.index}_use_slotting_checkbox`"
                      >
                        <span
                          style="margin: 0"
                          :id="`five_six_setting_knife_table_${scope.row.index}_use_slotting_checkbox_label`"
                          >{{ $translateLang('加工槽') }}</span
                        >
                      </a-checkbox>
                    </a-checkbox-group>
                  </div>
                  <div
                    v-else-if="
                      scope.row.index === rowIndex &&
                      scope.column.index === columnIndex &&
                      knife.props !== 'idx' &&
                      knife.props !== 'use'
                    "
                  >
                    <el-input
                      v-model="scope.row[knife.props]"
                      ref="editInput"
                      type="textarea"
                      size="mini"
                      resize="none"
                      autosize
                      @blur="inputBlur(scope.row, knife.props)"
                      @change="inputBlur(scope.row, knife.props)"
                      @input="
                        handleKnivesInputCheck(
                          scope.row,
                          knife.props,
                          knife.isCheck
                        )
                      "
                      :id="`five_six_setting_knife_table_${scope.row.index}_${knife.props}_input`"
                    />
                  </div>
                  <div
                    class="knives_type"
                    style="white-space: pre-line"
                    v-else-if="knife.props !== 'idx' && knife.props !== 'use'"
                    :id="`five_six_setting_knife_table_${scope.row.index}_${knife.props}`"
                  >
                    {{ scope.row[knife.props] }}
                    <span
                      :class="[
                        'iconfont',
                        'icon-revise',
                        { 'icon-revise-show': scope.row[knife.props] },
                      ]"
                      style="color: #18a8c7"
                    ></span>
                  </div>
                  <div class="knives_type" style="white-space: pre-line" v-else>
                    {{ scope.row[knife.props] }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="knives-tip">
              <p id="p_ngsg35tz3q">
                ({{
                  $translateLang('1、设置铣异形刀后切割路径将补偿其刀半径')
                }})
              </p>
              <p id="p_6fv6ao9los">
                ({{ $translateLang('2、异形切割暂不支持xy轴互换的雕刻机') }})
              </p>
            </div>
          </div>
          <div class="operation-btn flex flex-cross--center">
            <a-button
              @click="handleAddNewKnife"
              class="mr12"
              id="five_six_setting_knife_table_add_row"
              >{{ $t('cuttingDock.knives.insert') }}</a-button
            >
            <a-button
              @click="handleDeleteKnife"
              class="danger-btn"
              id="five_six_setting_knife_table_delete_row"
              :class="{ 'disabled-btn': knives.length < 2 }"
              >{{ $t('cuttingDock.knives.delete') }}</a-button
            >
          </div>
        </div>
      </div>
      <!-- 五面钻特殊参数 -->
      <div v-if="showFiveDockSpecial">
        <div class="five-special-setting">
          <span id="span_yfzupd862n" class="head-title">{{
            $t('dock56Drill.specialParameter')
          }}</span>
          <div class="content">
            <span id="span_71vwjczp00" class="small-title">{{
              $t('dock56Drill.output5FDrillSlotKnifeCode')
            }}</span>
            <a-input
              v-model="output5FDrillSlotKnifeCode"
              id="fiveSix_setting_output5FDrillSlotKnifeCode_input"
            ></a-input>
          </div>
          <div class="content">
            <span id="span_jp6uztmv90" class="small-title">{{
              $t('dock56Drill.output5FDrillShapeKnifeCode')
            }}</span>
            <a-input
              v-model="output5FDrillShapeKnifeCode"
              id="fiveSix_setting_output5FDrillShapeKnifeCode_input"
            ></a-input>
          </div>
          <div class="content display">
            <span id="span_7ixaghfnrx" class="small-title">{{
              $t('dock56Drill.plankTexture')
            }}</span>
            <div class="tex-dir">
              <span id="span_zlptbwmwfx" class="small-title"
                >{{ $t('common.reverse') }}=</span
              >
              <a-input
                v-model="output5FDrillNormalTexdirCode"
                id="fiveSix_setting_output5FDrillNormalTexdirCode_input"
              ></a-input>
            </div>
            <div class="tex-dir">
              <span id="span_jmfszm5j14" class="small-title"
                >{{ $t('common.normal') }}=</span
              >
              <a-input
                v-model="output5FDrillReverseTexdirCode"
                id="fiveSix_setting_output5FDrillReverseTexdirCode_input"
              ></a-input>
            </div>
          </div>
          <div class="content">
            <span id="span_0wxvu983kn" class="small-title">{{
              $t('dock56Drill.offset')
            }}</span>
            <a-input
              v-model="output5FDrillShapeKnifeOffset"
              id="fiveSix_setting_output5FDrillShapeKnifeOffset_input"
            ></a-input>
          </div>
          <div class="content" v-if="selectedDockFile == 'mpr'">
            <span id="span_wyu6w3u0fj" class="mr20 fs16">{{
              $t('dock56Drill.mprConHoleDir')
            }}</span>
            <a-radio-group v-model="dock56FDrillMprConHoleDir">
              <a-radio
                :value="false"
                id="fiveSix_setting_dock56FDrillMprConHoleDir_false_radio"
                >+{{ $t('dock56Drill.plankTop') }}</a-radio
              >
              <a-radio
                :value="true"
                id="fiveSix_setting_dock56FDrillMprConHoleDir_trueradio"
                >+{{ $t('dock56Drill.plankBottom') }}</a-radio
              >
            </a-radio-group>
          </div>
        </div>
      </div>
      <div class="" v-if="showSixDockSpecial">
        <div class="six-special-setting">
          <span id="span_fdeayc7u2d" class="head-title">{{
            $t('dock56Drill.specialParameter')
          }}</span>
          <div class="content" v-if="selectedDockFile == 'ban'">
            <span id="span_deszl7tqx5" class="small-title">{{
              $t('dock56Drill.codeInfo')
            }}</span>
            <a-checkbox
              v-model="dock6FDrill_code"
              id="fiveSix_setting_dock6FDrill_code_checkbox"
            ></a-checkbox>
          </div>
          <div class="content" v-if="selectedDockFile == 'ban'">
            <span id="span_xx9klxmuyn" class="small-title">{{
              $t('dock56Drill.bomFile')
            }}</span>
            <a-checkbox
              v-model="utf8bom"
              id="fiveSix_setting_utf8bom_checkbox"
            ></a-checkbox>
          </div>
          <div class="content" v-if="selectedDockFile == 'ban'">
            <span id="span_9jwndjjo4e" class="small-title">{{
              $t('dock56Drill.plankHeight')
            }}</span>
            <a-radio-group v-model="dock6FDrill_plankHeight">
              <a-radio
                value="hight"
                id="fiveSix_setting_dock6FDrill_plankHeight_hight_radio"
                >Hight</a-radio
              >
              <a-radio
                value="height"
                id="fiveSix_setting_dock6FDrill_plankHeight_height_radio"
                >Height</a-radio
              >
            </a-radio-group>
          </div>
          <div class="content" v-if="selectedDockFile == 'ban'">
            <span id="span_syq2wng896" class="small-title">{{
              $t('dock56Drill.plankNum')
            }}</span>
            <a-checkbox-group v-model="dock6FDrill_plankCode">
              <a-checkbox
                value="Code"
                id="fiveSix_setting_dock6FDrill_plankCode_code_checkbox"
                >Code</a-checkbox
              >
              <a-checkbox
                value="Code1"
                id="fiveSix_setting_dock6FDrill_plankCode_code1_checkbox"
                >Code1</a-checkbox
              >
            </a-checkbox-group>
          </div>
          <div class="content" v-if="selectedDockFile == 'ban'">
            <span id="span_p7g7c6h8ya" class="small-title">{{
              $t('dock56Drill.backZpoint')
            }}</span>
            <a-radio-group v-model="dock6FDrill_zValue">
              <a-radio
                :value="0"
                id="fiveSix_setting_dock6FDrill_zValue_0_radio"
                >-({{ $t('dock56Drill.plankThick') }}-{{
                  $t('dock56Drill.slotDeep')
                }})</a-radio
              >
              <a-radio
                :value="1"
                id="fiveSix_setting_dock6FDrill_zValue_1_radio"
                >-({{ $t('dock56Drill.slotDeep') }})</a-radio
              >
            </a-radio-group>
          </div>
          <div class="content need-bottom" v-if="selectedDockFile == 'mpr'">
            <div class="mb10">
              <span id="span_jichke3bna" class="small-title">{{
                $t('dock56Drill.outputMprFile')
              }}</span>
              <a-radio-group v-model="dock6FOutputMprFile">
                <a-radio
                  value="mpr"
                  id="fiveSix_setting_dock6FOutputMprFile_mpr_radio"
                  >{{ $t('dock56Drill.oldMPR') }}</a-radio
                >
                <a-radio
                  value="newMpr"
                  id="fiveSix_setting_dock6FOutputMprFile_newMpr_radio"
                  >{{ $t('dock56Drill.newMPR') }}</a-radio
                >
              </a-radio-group>
            </div>
            <div v-if="dock6FOutputMprFile === 'mpr'">
              <span id="span_401bk51j65" class="mr20 fs16">{{
                $t('dock56Drill.mprFileZside')
              }}</span>
              <a-radio-group v-model="dock56FDrillMprConHoleDir">
                <a-radio
                  :value="false"
                  id="fiveSix_setting_dock56FDrillMprConHoleDir_false_radio"
                  >+{{ $t('dock56Drill.plankTop') }}</a-radio
                >
                <a-radio
                  :value="true"
                  id="fiveSix_setting_dock56FDrillMprConHoleDir_true_radio"
                  >+{{ $t('dock56Drill.plankBottom') }}</a-radio
                >
              </a-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <m-lock-modal
      :visible.sync="isShowVisible"
      :status.sync="lockStatus"
      :tempStatus.sync="tempStatus"
      :verifyPassword="verifyPassword"
      :lineName="$route.query.line"
      codeType="bluen_update_production"
      @getLockPassword="handleGetLockPassword"
      @handleChangePasswordState="handleChangePasswordState"
    ></m-lock-modal>
    <!-- 修改记录弹窗 -->
    <m-change-record-modal
      :visible.sync="showRecordModal"
      operate_equipment="dock56FDrill"
      @success="handleSuccess"
      ref="recordModalRef"
    />
  </div>
</template>

<script>
import { buryPoint } from '@/apis/common/buryPoint'
import { getEquipmentPermission } from '@/apis/equipment'
import { getLockStatus } from '@/apis/productionLineLock'
import { Navigate } from '@/components/g-search/utils'
import breadcrumb from '@/components/topBreadCrumb.vue'
import store from '@/store'
import {
  genFinalRecord,
  genFinalRecordPromise,
  genUniId,
  verifyInputNumber,
} from '@/util/commonFuncs'
import { operateRecordTableType, webId } from '@/util/configure'
import {
  dockFiveSixFormTextObj,
  dockFiveSixFormValueObj,
} from '@/util/operateRecordConfigure/dockFiveSixConfigure'
import { regReplaceCuttingDockInputCheck } from '@/util/regReplace'
import { saveDataJsonToOssForRecord } from '@/util/saveFile'
import MChangeRecordModal from '@/views/equipment/component/m-change-record-modal.vue'
import MLockModal from '@/views/equipment/component/m-lock-modal.vue'
import { mapState } from 'vuex'

import DockFiveSixSample from './component/dockFiveSixSample.vue'

export default {
  components: {
    breadcrumb,
    DockFiveSixSample,
    MLockModal,
    MChangeRecordModal,
  },
  data() {
    return {
      lockStatus: 1, // 锁状态
      verifyPassword: true,
      tempStatus: 1, //默认状态
      isShowVisible: false,
      // 是否使用文件自定义
      dock56FDrill_customFile: false,
      // 是否为天工
      showTiangong: false,
      // 记录选择的五六面钻文件
      selectedDockFile: '',
      // 记录五面钻的文件类型
      selectFiveList: [
        { name: 'XML', value: 'xml' },
        { name: 'XML2', value: 'xml2' },
        { name: 'XML3', value: 'xml3' },
        { name: 'MPR', value: 'mpr' },
      ],
      // 记录选中的五面钻文件类型
      dock5FDrill_fileType: 'xml',
      // 记录六面钻的文件类型
      selectSixList: [
        { name: 'BAN', value: 'ban' },
        { name: 'XML1', value: 'xml1' },
        { name: 'XML3', value: 'xml3' },
        { name: 'MPR', value: 'mpr' },
      ],
      // 记录五六面钻的文件类型
      dockFiveSixList: [],
      // 记录选中的六面钻文件类型
      dock6FDrill_fileType: 'ban',
      // 记录选中的刀具
      dockType: 'fiveDock',
      is_output56FDrillLayoutDir: true,
      // 板件长边摆放方向
      output56FDrillLayoutDir: 'Vertical',
      // 五六面钻槽和异形摆放优
      selectedOutput56DrillSoltDir: true,
      // 五六面钻槽或异形放置方向
      output56FDrillSlotDir: 'default',
      // 生效范围:
      long_edge_rotate_range: 1200,
      // 桦桦自动线
      automation: false,
      // 坐标值保留位数
      output56FDrillDecimalNum: '2',
      // xml2铣槽刀具编号
      output5FDrillSlotKnifeCode: '',
      // xml2铣型刀具编号
      output5FDrillShapeKnifeCode: '',
      // xml2板件纹理 横纹
      output5FDrillReverseTexdirCode: '',
      // xml2板件纹理 竖纹
      output5FDrillNormalTexdirCode: '',
      output5FDrillShapeKnifeOffset: '',
      // 通孔分双面打通
      dock6FDrill_towSideConHole: false,
      // 通槽分双面打通
      dock56FDrill_twoSideConSlot: false,
      // 矩形版没有孔槽不输出文件
      non_holes_not_files: false,
      // ban格式文件包含Code信息
      dock6FDrill_code: false,
      // 输出bom格式文件
      utf8bom: false,
      // 板件高度描述
      dock6FDrill_plankHeight: '',
      // 板号描述
      dock6FDrill_plankCode: [],
      // 反面槽Z坐标
      dock6FDrill_zValue: 0,
      // mpr文件类型
      dock6FOutputMprFile: 'mpr',
      // mpr侧面孔Z坐标基准面
      dock56FDrillMprConHoleDir: true,
      // 正面文件标识
      front_file_identifier: '',
      // 反面文件标识
      opposite_file_identifier: 'K',
      // 圆弧描述方式
      arc_description: 'arc_command',
      // 记录是否可以进行保存
      ableSaveSetting: false,
      // 记录当前五六面钻模板是否被下线
      isNotOnline: false,
      // 宽槽拆解为多条窄槽加工
      split_slot: true,
      // 拆解后单条槽宽度
      single_width: '',
      oriFormData: {},
      // 是否显示样例
      showSample: false,
      // 固定前封边
      is_front_edge_fixed: false,
      // 前封边固定在什么方向
      front_edge_fixed_direction: 'left',
      //相邻等宽等深槽是否拉通处理
      isNotMergeSlot: false,
      //等宽等深槽相邻尺寸大小
      adjacentSize: 3,
      // 后端使用数量字段要求
      old_file_type: '',
      // 设置一个辅助值限制输入
      limitValue: '',
      showRecordModal: false,
      /** 异形夹手设置 1、2、3*/
      plankPlacement: 2,
      fixtureSetting: {
        // 夹手方向(夹手所在方向front,back,left,right)
        fixtureDirection: 'left',
        // 夹手宽度
        fixtureWidth: 50,
        // 夹手长度
        fixtureLength: 130,
        // 设备最大加工宽度
        machineMaxWidth: 1220,
      },
      /** 焊接板原边固定靠夹手 */
      welding_plate_placement: {
        enable: false,
        direction: 'left',
      },
      directionOptions: [
        { label: '前侧', value: 'front' },
        { label: '后侧', value: 'back' },
        { label: '左侧', value: 'left' },
        { label: '右侧', value: 'right' },
      ],
      smallPlankCondition: {
        longSide: 0,
        shortSide: 0,
      },
      /**距边为0的槽长度补偿 */
      slotEdge0Comp: 0,
      /** 距边为0的直角边长度补偿 */
      inner_shape_compensation_by_margin_le_0: 0,
      /**距边不为0的槽宽度补偿 */
      slotNoEdge0Comp: 0,
      // 记录刀库
      knives: [],
      // 记录行索引
      rowIndex: -1,
      // 记录列索引
      columnIndex: -1,
      // 记录当前选中的行
      currentRow: {},
      knivesColumns: [
        {
          label: '序号',
          props: 'idx',
          width: 90,
          isCheck: false,
        },
        {
          label: '刀直径Φ',
          props: 'diameter',
          width: 130,
          isCheck: false,
        },
        {
          label: '用途',
          props: 'use',
          width: 420,
          isCheck: false,
        },
        {
          label: '刀具编号',
          props: 'knife_name',
          width: 120,
          isCheck: false,
        },
      ],
      /** 内部异形切割下刀和收刀均在内侧 */
      internal_cut_inside: false,
      /** 外部异形切割下刀和收刀均在外侧 */
      external_cut_outside: false,
      /** 外部异形切割时，包含异形的整条边缘将同步切割 */
      cut_path_extension: false,
      /** 边缘类型 */
      cut_path_extension_mode: 'all', // all:"所有外异形"， arc:"仅圆弧与矩形边相切的外异形"
      sawPermission: false,
      /** 指定板件名摆放设置 */
      plank_name_placement: {
        is_open: false,
        rules: [],
      },
      /** 当前正在编辑板件名的行 webId */
      editingPlankNameId: '',
      plankDirectionOptions: [
        { label: '前边', value: 'front' },
        { label: '后边', value: 'back' },
        { label: '左边', value: 'left' },
        { label: '右边', value: 'right' },
        { label: '上边', value: 'top' },
        { label: '下边', value: 'bottom' },
      ],
      deviceSideOptions: [
        { label: '左边', value: 'left' },
        { label: '右边', value: 'right' },
        { label: '前边', value: 'front' },
        { label: '后边', value: 'back' },
      ],
    }
  },
  methods: {
    handleOpenFileManage() {
      this.$router.push({
        path: '/fileManage',
      })
    },
    handleAddRow() {
      if (this.plank_name_placement.rules.length >= 50) {
        this.$message.error('最多只能添加50条')
        return
      }
      this.plank_name_placement.rules.push({
        webId: genUniId(),
        plank_name: '',
        plank_edge: 'front',
        device_side: 'left',
      })
    },
    handleDelRow(index) {
      this.plank_name_placement.rules.splice(index, 1)
    },
    handleEditPlankNameCell(record) {
      this.editingPlankNameId = record.webId
      this.$nextTick(() => {
        const inputRef = this.$refs[`plankNameInput_${record.webId}`]
        const input = Array.isArray(inputRef) ? inputRef[0] : inputRef
        input?.focus?.()
      })
    },
    handleBlurPlankNameCell() {
      this.editingPlankNameId = ''
    },
    verifyInputNumber(
      val,
      verifyObj,
      keys,
      rule,
      isMinus = false,
      min = 0,
      isEmpty = false,
      max = 0
    ) {
      verifyInputNumber(val, verifyObj, keys, rule, isMinus, min, isEmpty, max)
    },
    // 选择夹手功能
    handlePlankPlacement(val) {
      this.plankPlacement = val.target.value
      if (val.target.value === 3) {
        this.is_front_edge_fixed = true
      } else {
        this.is_front_edge_fixed = false
      }
    },
    // 生效范围的输入检测
    handleInputCheck(e) {
      // 最多允许输入五位整数和两位小数，数据范围大于等于0
      // 正则表达式
      const reg = /^(\d{0,5})(\.(\d{0,2}))?$/g
      if (reg.test(e.target.value)) {
        this.limitValue = e.target.value
      }
      this.long_edge_rotate_range = this.limitValue
      // 修改输入框的值
      e.target.value = this.long_edge_rotate_range
    },
    getPopupContainer(triggerNode) {
      return triggerNode.parentElement || document.body
    },
    async handleGetLockPassword() {
      await this.saveDockFiveSix()
    },
    handleChangePasswordState(state) {
      this.verifyPassword = state
    },
    changeFileIdentifierFront(value) {
      this.front_file_identifier = value.replace(/[^\w]|[//]/g, '')
    },
    changeFileIdentifierOpposite(value) {
      this.opposite_file_identifier = value.replace(/[^\w]|[//]/g, '')
    },
    changeSingleWidth(value) {
      this.single_width = value
        .replace(/\D*(\d{0,3})\d*(\.?)(\d{0,3})\d*/, '$1$2$3')
        .replace(/[^\d\.]/g, '')
    },
    handleChangeAdjacentSize(value) {
      this.adjacentSize = value.replace(/^[^0-9]||[/.]/g, '')
      if (value.includes('.')) {
        const res = value.split('.')
        if (res.length > 2) {
          this.adjacentSize = res[0] + '.'
        }
        if (res[1].length > 1) {
          this.adjacentSize = res[0] + '.' + res[1][0]
        }
      } else {
        this.adjacentSize = this.adjacentSize[0]
      }
    },
    toCustomFile() {
      this.$router.push({
        path: '/customFile',
        query: {
          setting_id: this.$route.query.setting_id,
          line: this.$route.query.line,
        },
      })
    },
    goBackPage() {
      this.nowPath = ''
      let path = ''
      if (this.showTiangong) {
        path = '/equipment?from=tiangong'
      } else {
        path = '/equipment'
      }
      if (this.previewInfo.isPreview) {
        path = `${path}-preview`
      }

      this.$router.push(path)
    },
    // 输入检测
    // inputCheck(val){
    //   // this[val] = this[val].replace(/[^\d]/g, "") // 去除数字和小数点以外的数字
    // },
    // 修改选择的文件格式时, 更改状态
    changeSelectedDockFile() {
      if (this.isNotOnline && this.selectedDockFile != '') {
        this.isNotOnline = false
      }
    },
    genCompareData(current, ori) {
      const selectedDockFile = {}
      this.dockFiveSixList.forEach((item) => {
        selectedDockFile[
          item.dock56Format
        ] = `${item.modelName}【${item.dock56Format}】`
      })
      const dockFiveSixFormValueObjTemp = {
        ...dockFiveSixFormValueObj,
        selectedDockFile: selectedDockFile,
      }
      let specailParamsKeys = []
      if (
        this.selectedDockFile == 'xml2' &&
        this.dockType == 'fiveDock' &&
        !this.dock56FDrill_customFile
      ) {
        specailParamsKeys = [
          'output5FDrillSlotKnifeCode',
          'output5FDrillShapeKnifeCode',
          'output5FDrillNormalTexdirCode',
          'output5FDrillReverseTexdirCode',
          'output5FDrillShapeKnifeOffset',
        ]
      }

      if (this.dockType == 'sixDock' && !this.dock56FDrill_customFile) {
        specailParamsKeys = [
          'dock6FDrill_code',
          'utf8bom',
          'dock6FDrill_plankHeight',
          'dock6FDrill_plankCode',
          'dock6FDrill_zValue',
        ]
      }
      if (this.selectedDockFile == 'mpr') {
        specailParamsKeys = ['dock6FOutputMprFile']
        if (
          (this.dock6FOutputMprFile == 'mpr' && this.dockType == 'sixDock') ||
          this.dockType == 'fiveDock'
        ) {
          specailParamsKeys = [
            'dock6FOutputMprFile',
            'dock56FDrillMprConHoleDir',
          ]
        }
        if (this.dockType == 'fiveDock' && this.selectedDockFile == 'mpr') {
          specailParamsKeys = [
            'output5FDrillSlotKnifeCode',
            'output5FDrillShapeKnifeCode',
            'output5FDrillNormalTexdirCode',
            'output5FDrillReverseTexdirCode',
            'output5FDrillShapeKnifeOffset',
            'dock56FDrillMprConHoleDir',
          ]
        }
      }
      const compareMsg = [
        {
          title: '设备类型',
          keys: ['dockType'],
        },
        {
          title: '生成文件类型',
          keys: ['selectedDockFile'],
        },
        {
          title: '通用参数设置',
          keys: [
            'dock6FDrill_towSideConHole',
            'dock56FDrill_twoSideConSlot',
            'non_holes_not_files',
            'front_file_identifier',
            'opposite_file_identifier',
            'arc_description',
            'split_slot',
            'single_width',
            'output56FDrillLayoutDir',
            'is_output56FDrillLayoutDir',
            'selectedOutput56DrillSoltDir',
            'output56FDrillSlotDir',
            'output56FDrillDecimalNum',
            'is_front_edge_fixed',
            'front_edge_fixed_direction',
            'isNotMergeSlot',
            'adjacentSize',
            'automation',
            'long_edge_rotate_range',
            'fixtureSetting',
            'plankPlacement',
            'fixtureDirection',
            'fixtureWidth',
            'fixtureLength',
            'machineMaxWidth',
            'welding_plate_placement',
            'smallPlankCondition',
            'slotEdge0Comp',
            'inner_shape_compensation_by_margin_le_0',
            'slotNoEdge0Comp',
            'internal_cut_inside',
            'external_cut_outside',
            'cut_path_extension',
            'cut_path_extension_mode',
            'plank_name_placement',
          ],
        },
        {
          title: '特殊参数设置',
          keys: specailParamsKeys,
        },
        {
          title: '根据订单分为不同文件夹',
          keys: ['group_file'],
        },
      ]
      return {
        type: 'form',
        // 规则列表走独立表格对比，表单对比仅保留开关
        current: {
          ...current,
          plank_name_placement: {
            is_open: current.plank_name_placement?.is_open,
          },
        },
        ori: {
          ...ori,
          plank_name_placement: {
            is_open: ori.plank_name_placement?.is_open,
          },
        },
        compareMsg, // 要比较的内容
        formTextObj: dockFiveSixFormTextObj, // key对应的意思
        formValueObj: dockFiveSixFormValueObjTemp, // value对应的意思
      }
    },
    // 指定板件名摆放规则补全 webId，供操作记录表格 diff 使用
    ensurePlankNamePlacementRulesWebId(rules) {
      if (!Array.isArray(rules)) {
        return []
      }
      rules.forEach((rule) => {
        if (!rule[webId]) {
          this.$set(rule, webId, rule.id || genUniId())
        }
      })
      return rules
    },
    async genFinalRecordFn(current, ori, saveData, callback = null) {
      const currentTableList = Object.values(current.knives)
      const oriTableList = Object.values(ori.knives)
      const currentPlankNameRules = this.ensurePlankNamePlacementRulesWebId(
        current.plank_name_placement?.rules
      )
      const oriPlankNameRules = this.ensurePlankNamePlacementRulesWebId(
        ori.plank_name_placement?.rules
      )
      let recordData = {
        key: '五六面钻', // 操作记录最外层的名字，比如：雕刻机
        operateArr: [
          // 应对多个操作页面时，比如雕刻机的操作页面
          {
            key: '',
            dataArr: [
              // 氛围表单和table两种
              this.genCompareData(current, ori),
              {
                type: 'table',
                list: currentTableList,
                oriList: oriTableList,
                keys: [
                  'idx',
                  'diameter',
                  'milling_outer',
                  'milling_inner',
                  'drilling',
                  'slotting',
                  'knife_name',
                  'webId',
                ],
                tableType: operateRecordTableType.FIVE_SIX_KNIVES_TABLE,
                key: '刀库',
              },
              {
                type: 'table',
                list: currentPlankNameRules,
                oriList: oriPlankNameRules,
                keys: ['plank_name', 'plank_edge', 'device_side', 'webId'],
                tableType: operateRecordTableType.PLANK_NAME_PLACEMENT_TABLE,
                key: '指定板件名摆放列表',
              },
            ],
          },
        ],
      }
      // genFinalRecord(recordData, 'equipment_docking', () => {
      //   if (this.$route.query.setting_id) {
      //     this.getAllDock56File()
      //   }
      // })
      try {
        const res = await genFinalRecordPromise(recordData, 'equipment_docking')
        if (res) {
          const { record, finalId, action_type } = res
          saveDataJsonToOssForRecord(
            record,
            action_type,
            {
              id: finalId,
              operate_equipment: 'dock56FDrill',
              save_data: saveData,
              setting_id: this.$route.query.setting_id,
              operatorPhone: this.previewInfo.operatorPhone,
            },
            () => {
              if (!this.previewInfo?.isApply) {
                this.getAllDock56File()
              }
              callback && callback()
            }
          )
        }
      } catch (error) {
        this.$message({
          message: '生成操作记录失败',
          type: 'error',
        })
      }
    },
    // 保存五六面钻设置
    saveDockFiveSix() {
      // if (this.selectedDockFile == '') {
      //   this.$message({
      //     message: '请选择生成文件类型!',
      //     type: 'error',
      //   })
      //   return
      // }
      // 校验板件长边输入的正确性 需要在前封边关闭且五/六面钻槽或异形放置方向勾选时才生效
      if (
        this.long_edge_rotate_range === '' &&
        this.selectedOutput56DrillSoltDir &&
        !this.is_front_edge_fixed
      ) {
        // 不合法的输入，不让保存，弹出提示并滑动定位到指定位置
        let dom = document.getElementById(
          'fiveSix_setting_longEdgeRotateRange_input'
        )
        dom.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        })
        return this.$message({
          message: '板件长边范围不允许为空',
          type: 'warning',
        })
      }
      // 刀库-刀具编号重复
      const knifeNames = this.knives.map((item) => item.knife_name)
      if (
        knifeNames.some((item) => !item) ||
        new Set(knifeNames).size !== knifeNames.length
      ) {
        let dom = document.getElementById('five-six-knives-table')
        dom.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        })
        return this.$message({
          message: '刀库-刀具编号重复或为空，请检查',
          type: 'warning',
        })
      }
      // 判断锁定状态，打开弹窗
      // 根据获取的状态 锁定状态
      this.lockStatus = this.tempStatus
      let formData = {
        dock5FDrill: this.dockType == 'fiveDock' ? true : false,
        dock6FDrill: this.dockType == 'fiveDock' ? false : true,
        selectedOutput56DrillSoltDir: this.selectedOutput56DrillSoltDir,
        is_output56FDrillLayoutDir: this.is_output56FDrillLayoutDir,
        output56FDrillSlotDir: this.output56FDrillSlotDir,
        long_edge_rotate_range:
          this.long_edge_rotate_range === ''
            ? ''
            : Number(this.long_edge_rotate_range),
        automation: this.automation,
        welding_plate_placement: this.welding_plate_placement,
        smallPlankCondition: {
          longSide: Number(this.smallPlankCondition.longSide),
          shortSide: Number(this.smallPlankCondition.shortSide),
        },
        output56FDrillDecimalNum: Number(this.output56FDrillDecimalNum),
        output56FDrillLayoutDir: this.output56FDrillLayoutDir,
        output5FDrillSlotKnifeCode: this.output5FDrillSlotKnifeCode,
        output5FDrillShapeKnifeCode: this.output5FDrillShapeKnifeCode,
        output5FDrillNormalTexdirCode: this.output5FDrillNormalTexdirCode,
        output5FDrillShapeKnifeOffset: this.output5FDrillShapeKnifeOffset,
        output5FDrillReverseTexdirCode: this.output5FDrillReverseTexdirCode,
        dock5FDrill_fileType: this.dock5FDrill_fileType,
        dock6FDrill_fileType: this.dock6FDrill_fileType,
        dock6FDrill_towSideConHole: this.dock6FDrill_towSideConHole,
        dock56FDrill_twoSideConSlot: this.dock56FDrill_twoSideConSlot,
        non_holes_not_files: this.non_holes_not_files,
        dock6FDrill_code: this.dock6FDrill_code,
        utf8bom: this.utf8bom,
        dock6FDrill_plankHeight: this.dock6FDrill_plankHeight,
        dock6FDrill_plankCode: this.dock6FDrill_plankCode,
        dock6FOutputMprFile: this.dock6FOutputMprFile,
        dock6FDrill_zValue: this.dock6FDrill_zValue,
        dock56FDrill_customFile: this.dock56FDrill_customFile,
        front_file_identifier: this.front_file_identifier,
        opposite_file_identifier: this.opposite_file_identifier,
        arc_description: this.arc_description,
        split_slot: this.split_slot,
        single_width: this.single_width,
        group_file: this.group_file ? 'split_by_order' : 'none',
        is_front_edge_fixed: this.is_front_edge_fixed,
        plankPlacement: this.plankPlacement,
        fixtureSetting: {
          ...this.fixtureSetting,
          fixtureLength: Number(this.fixtureSetting.fixtureLength),
          machineMaxWidth: Number(this.fixtureSetting.machineMaxWidth),
          fixtureWidth: Number(this.fixtureSetting.fixtureWidth),
        },
        front_edge_fixed_direction: this.front_edge_fixed_direction,
        dock56FDrillMprConHoleDir: this.dock56FDrillMprConHoleDir,
        isNotMergeSlot: this.isNotMergeSlot,
        adjacentSize: this.adjacentSize,
        old_file_type: this.old_file_type,
        slotEdge0Comp: this.slotEdge0Comp,
        inner_shape_compensation_by_margin_le_0:
          this.inner_shape_compensation_by_margin_le_0,
        slotNoEdge0Comp: this.slotNoEdge0Comp,
        internal_cut_inside: this.internal_cut_inside,
        external_cut_outside: this.external_cut_outside,
        cut_path_extension: this.cut_path_extension,
        cut_path_extension_mode: this.cut_path_extension_mode,
        plank_name_placement: {
          is_open: this.plank_name_placement.is_open,
          rules: this.ensurePlankNamePlacementRulesWebId(
            this.plank_name_placement.rules || []
          ),
        },
      }
      formData.dock5FDrill_fileType = this.selectedDockFile
      formData.dock6FDrill_fileType = this.selectedDockFile
      // 刀库处理
      let s = this.knives.reduce((prev, cur) => {
        // 修改此处的顺序，解决首次保存时，转json与原始数据对比时，顺序不一致的问题
        prev[cur.knife_name] = {
          idx: cur.idx,
          diameter: cur.diameter ? Number(cur.diameter) : cur.diameter,
          milling_outer: cur.knifePurpose.includes('milling_outer'),
          milling_inner: cur.knifePurpose.includes('milling_inner'),
          drilling: cur.knifePurpose.includes('drilling'),
          slotting: cur.knifePurpose.includes('slotting'),
          knife_name: cur.knife_name,
          webId: cur.webId,
        }
        return prev
      }, {})
      formData.knives = s
      let data = {
        setting_id: this.$route.query.setting_id,
        data: formData,
        ...store.state.saveInfo,
        platform: 'bluen',
      }
      this.ableSaveSetting = false
      this.$store.commit('setCurrentProductLineName', this.$route.query.line)
      this.$token('/save_dock56F_setting', data, (res) => {
        this.ableSaveSetting = true
        if (res.status == 1) {
          this.isShowVisible = false
          this.$message({
            message: this.$t('common.saveSuccess'),
            type: 'success',
            duration: 1500,
            offset: 70,
          })
          try {
            this.genFinalRecordFn(
              {
                ...formData,
                selectedDockFile: this.selectedDockFile,
                dockType: this.dockType,
              },
              this.oriFormData,
              data
            )
          } catch (error) {
            console.error('error', error)
          }
          if (res.data.phone && res.data.request_ip) {
            let recordData = {
              key: '保存设置',
              operateArr: [
                {
                  key: '生产线设置',
                  dataArr: [
                    {
                      type: 'form',
                      current: {
                        phone: res.data.phone,
                        time: new Date().toLocaleString(),
                        id: store.state.userInfo.id,
                        ip: res.data.request_ip,
                      },
                      ori: {
                        phone: '',
                        time: '',
                        id: '',
                        ip: '',
                      },
                      compareMsg: [
                        {
                          title: '',
                          keys: ['phone', 'time', 'id', 'ip'],
                        },
                      ],
                      formTextObj: {
                        phone: '手机号',
                        time: '保存时间',
                        id: '用户id',
                        ip: '物理地址',
                      },
                      formValueObj: {},
                    },
                  ],
                },
              ],
            }
            genFinalRecord(recordData, 'equipment_docking', '', () => {})
          }
          // 刀库修改埋点
          if (
            JSON.stringify(formData.knives) !==
            JSON.stringify(this.oriFormData.knives)
          ) {
            buryPoint({
              function_module: 'dock56f',
              function_point: 'edit_knives',
            })
          }
          if (
            formData.plank_name_placement.is_open &&
            formData.plank_name_placement.is_open !==
              this.oriFormData.plank_name_placement.is_open
          ) {
            buryPoint({
              function_module: 'dock56f',
              function_point: 'enable_plank_name_placement',
            })
          }
        } else if (res.status == -1) {
          if (store.state.saveInfo.phone) {
            this.$message({
              message: res.msg,
              type: 'error',
              duration: 1500,
              offset: 70,
            })
          }
          this.showSaveModal()
        } else {
          this.$message({
            message: res?.msg || this.$t('lineManager.permissionTip'),
            type: 'error',
            duration: 1500,
            offset: 70,
          })
        }
        store.commit('setSaveInfo', {})
      })
    },
    showSaveModal() {
      this.lockStatus = this.tempStatus
      this.verifyPassword = true
      this.isShowVisible = true
      return
    },
    // 生成formData
    genOriFormData(res) {
      this.oriFormData = {
        dockType: this.dockType,
        selectedDockFile: this.selectedDockFile,
        dock6FDrill_towSideConHole: this.dock6FDrill_towSideConHole,
        dock56FDrill_twoSideConSlot: this.dock56FDrill_twoSideConSlot,
        non_holes_not_files: this.non_holes_not_files,
        front_file_identifier: this.front_file_identifier,
        opposite_file_identifier: this.opposite_file_identifier,
        arc_description: this.arc_description,
        split_slot: this.split_slot,
        single_width: this.single_width,
        output56FDrillLayoutDir: this.output56FDrillLayoutDir,
        selectedOutput56DrillSoltDir: this.selectedOutput56DrillSoltDir,
        is_output56FDrillLayoutDir: this.is_output56FDrillLayoutDir,
        output56FDrillSlotDir: this.output56FDrillSlotDir,
        long_edge_rotate_range: this.long_edge_rotate_range,
        automation: this.automation,
        welding_plate_placement: JSON.parse(
          JSON.stringify(this.welding_plate_placement)
        ),
        smallPlankCondition: JSON.parse(
          JSON.stringify(this.smallPlankCondition)
        ),
        output56FDrillDecimalNum: Number(this.output56FDrillDecimalNum),
        output5FDrillSlotKnifeCode: this.output5FDrillSlotKnifeCode,
        output5FDrillShapeKnifeCode: this.output5FDrillShapeKnifeCode,
        output5FDrillNormalTexdirCode: this.output5FDrillNormalTexdirCode,
        output5FDrillShapeKnifeOffset: this.output5FDrillShapeKnifeOffset,
        output5FDrillReverseTexdirCode: this.output5FDrillReverseTexdirCode,
        dock6FDrill_code: this.dock6FDrill_code,
        utf8bom: this.utf8bom,
        dock6FDrill_plankHeight: this.dock6FDrill_plankHeight,
        dock6FDrill_plankCode: this.dock6FDrill_plankCode,
        dock6FDrill_zValue: this.dock6FDrill_zValue,
        dock6FOutputMprFile: this.dock6FOutputMprFile,
        group_file: this.group_file ? 'split_by_order' : 'none',
        is_front_edge_fixed: this.is_front_edge_fixed,
        plankPlacement: this.plankPlacement,
        fixtureSetting: JSON.parse(JSON.stringify(this.fixtureSetting)),
        front_edge_fixed_direction: this.front_edge_fixed_direction,
        dock56FDrillMprConHoleDir: this.dock56FDrillMprConHoleDir,
        isNotMergeSlot: this.isNotMergeSlot,
        adjacentSize: this.adjacentSize,
        slotEdge0Comp: this.slotEdge0Comp,
        inner_shape_compensation_by_margin_le_0:
          this.inner_shape_compensation_by_margin_le_0,
        slotNoEdge0Comp: this.slotNoEdge0Comp,
        knives: JSON.parse(JSON.stringify(res.data.knives)),
        internal_cut_inside: this.internal_cut_inside,
        external_cut_outside: this.external_cut_outside,
        cut_path_extension: this.cut_path_extension,
        cut_path_extension_mode: this.cut_path_extension_mode,
        plank_name_placement: JSON.parse(
          JSON.stringify(this.plank_name_placement)
        ),
      }
    },
    // 读取五六面钻所有文件
    getAllDock56File() {
      this.$get(
        '/dock56F_list',
        {
          from: 'user',
        },
        (res) => {
          if (res.status == 1) {
            this.dockFiveSixList = res.data.model_list
            this.getDockFiveSix(this.$route.query.setting_id)
          }
        }
      )
    },
    // 读取五六面钻设置
    getDockFiveSix(id) {
      this.$token(
        '/load_dock56F_setting',
        {
          setting_id: id,
        },
        (res) => {
          if (res.status == 1) {
            this.dealWithFiveSixSetting(res)
            this.genOriFormData(res)
            // 后台应用生产线时进入
            if (this.previewProductLine?.dock56) {
              this.dealWithFiveSixSetting({
                data: this.previewProductLine?.dock56,
              })
            }
          } else {
            this.$message({
              type: 'info',
              message: this.$t('dock56Drill.permissionErr'),
              duration: 1500,
              offset: 70,
            })
          }
        }
      )
    },
    handleGetLockStatus() {
      //TODO 进入页面，获取生产线设置锁的状态
      getLockStatus().then((res) => {
        // 拿到的锁状态赋值，当前是锁定还是解锁状态
        this.lockStatus = res?.data?.is_lock || 0
        this.tempStatus = res?.data?.is_lock || 0
      })
    },
    // 打开修改记录弹窗
    handleOpenChangeRecord() {
      this.showRecordModal = true
    },
    // 还原参数后的回调
    handleSuccess(newData) {
      const { data } = newData
      this.genFinalRecordFn(
        {
          ...data,
          selectedDockFile: data.dock5FDrill_fileType,
          dockType: data.dock5FDrill ? 'fiveDock' : 'sixDock',
        },
        this.oriFormData,
        newData,
        () => {
          this.$refs['recordModalRef']?.getData({ isReset: true })
        }
      )
    },

    // 初始化处理五六面钻设置
    dealWithFiveSixSetting(res) {
      this.ableSaveSetting = true
      this.dockType = res.data.dock5FDrill ? 'fiveDock' : 'sixDock'
      this.selectedOutput56DrillSoltDir = res.data.selectedOutput56DrillSoltDir
      this.is_output56FDrillLayoutDir = res.data.is_output56FDrillLayoutDir
      this.output56FDrillSlotDir = res.data.output56FDrillSlotDir
      this.long_edge_rotate_range = res.data.long_edge_rotate_range
      this.automation = res.data.automation
      this.welding_plate_placement = res.data.welding_plate_placement
      this.smallPlankCondition = res.data.smallPlankCondition
      this.output56FDrillDecimalNum = res.data.output56FDrillDecimalNum
      this.output56FDrillLayoutDir = res.data.output56FDrillLayoutDir
      this.output5FDrillSlotKnifeCode = res.data.output5FDrillSlotKnifeCode
      this.output5FDrillShapeKnifeCode = res.data.output5FDrillShapeKnifeCode
      this.output5FDrillNormalTexdirCode =
        res.data.output5FDrillNormalTexdirCode
      this.output5FDrillShapeKnifeOffset =
        res.data.output5FDrillShapeKnifeOffset
      this.output5FDrillReverseTexdirCode =
        res.data.output5FDrillReverseTexdirCode
      this.dock5FDrill_fileType = res.data.dock5FDrill_fileType
      this.dock6FDrill_fileType = res.data.dock6FDrill_fileType
      this.dock6FDrill_towSideConHole = res.data.dock6FDrill_towSideConHole
      this.dock56FDrill_twoSideConSlot = res.data.dock56FDrill_twoSideConSlot
      this.non_holes_not_files = res.data.non_holes_not_files
      this.dock6FDrill_code = res.data.dock6FDrill_code
      this.utf8bom = res.data.utf8bom
      this.dock6FDrill_plankHeight = res.data.dock6FDrill_plankHeight
      this.dock6FDrill_plankCode = res.data.dock6FDrill_plankCode
      this.dock6FOutputMprFile = res.data.dock6FOutputMprFile
      this.dock6FDrill_zValue = res.data.dock6FDrill_zValue
      this.dock56FDrillMprConHoleDir = res.data.dock56FDrillMprConHoleDir
      this.dock56FDrill_customFile = false
      this.plank_name_placement = res.data.plank_name_placement || {
        is_open: false,
        rules: [],
      }
      this.ensurePlankNamePlacementRulesWebId(this.plank_name_placement.rules)
      this.old_file_type =
        this.dockType == 'fiveDock'
          ? res.data.dock5FDrill_fileType
          : res.data.dock6FDrill_fileType
      let selectedDockFile =
        this.dockType == 'fiveDock'
          ? this.dock5FDrill_fileType
          : this.dock6FDrill_fileType
      // 刀库处理
      let a = []
      Object.keys(res.data.knives).forEach((v) => {
        a.push(res.data.knives[v])
      })
      let knives = a
      let ss = ['milling_outer', 'milling_inner', 'drilling', 'slotting']
      knives.forEach((v) => {
        v.knifePurpose = []
        ss.forEach((x) => {
          if (v[x] == true) {
            v.knifePurpose.push(x)
          }
        })
      })
      this.knives = knives
      let data = this.dockFiveSixList.find(
        (v) => v.dock56Format == selectedDockFile
      )
      if (!data) {
        this.isNotOnline = true
        this.selectedDockFile = ''
        this.$message({
          message: this.$t('dock56Drill.fileTypeOffline'),
          type: 'info',
        })
      } else {
        this.selectedDockFile = selectedDockFile
      }
      this.opposite_file_identifier = res.data.opposite_file_identifier
      this.front_file_identifier = res.data.front_file_identifier
      this.fixtureSetting = res.data.fixtureSetting
      this.plankPlacement = res.data.plankPlacement
      this.is_front_edge_fixed = this.plankPlacement == 3
      this.front_edge_fixed_direction = res.data.front_edge_fixed_direction
      this.isNotMergeSlot = res.data.isNotMergeSlot
      this.adjacentSize = res.data.adjacentSize ?? '3'
      ;(this.arc_description = res.data.arc_description),
        (this.split_slot = res.data.split_slot),
        (this.single_width = res.data.single_width)
      this.group_file = res.data.group_file === 'split_by_order'
      this.slotEdge0Comp = res.data.slotEdge0Comp
      this.inner_shape_compensation_by_margin_le_0 =
        res.data.inner_shape_compensation_by_margin_le_0
      this.slotNoEdge0Comp = res.data.slotNoEdge0Comp
      this.internal_cut_inside = res.data.internal_cut_inside
      this.external_cut_outside = res.data.external_cut_outside
      this.cut_path_extension = res.data.cut_path_extension
      this.cut_path_extension_mode = res.data.cut_path_extension_mode
    },

    // 输入值格式化
    formatInputValue(key, e) {
      // 使用正则判断输入的是否是正数，并且最多只能有两位小数，不能以0开头(除了0本身)
      const reg = /^([1-9]\d{0,4}|0)(\.\d{1,2})?$/
      const value = e.target.value
      if (value === '') return (this[key] = 0)

      if (reg.test(value)) this[key] = Number(value)
    },

    // 输入框失焦时，添加操作埋点
    handleBlurAddBurypoint(key) {
      buryPoint({ function_module: 'dock56f', function_point: key })
    },
    // 更改行样式
    changeStyle({ row, rowIndex }) {
      if (this.currentRow.index == rowIndex) {
        return {
          height: '54px',
          'border-top': '1px solid #EEEEEE',
          'font-size': '14px',
          color: '#000000',
          'font-weight': '400',
          background: 'rgba(24, 168, 199, 0.2)',
        }
      }
      return {
        height: '54px',
        'border-top': '1px solid #EEEEEE',
        'font-size': '14px',
        color: '#000000',
        'font-weight': '400',
      }
    },
    // 更改表头单元格样式
    headerStyle() {
      return 'background: #fafafa'
    },
    // 更改表头行样式
    headerRowStyle() {
      return {
        height: '54px',
        'font-size': '14px',
        color: '#000000',
        'font-weight': '500',
        'border-bottom': 'none',
      }
    },
    // 选中刀具
    choseKnife(row) {
      this.currentRow = row
    },
    //把每一行的索引加到行数据中
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    //把每一列的索引加到列数据中
    tableCellClassName({ column, columnIndex }) {
      column.index = columnIndex
    },
    // 点击单元格切换成输入框
    cellClick(row, column) {
      if (column.property == 'idx') {
        return
      }
      this.rowIndex = row.index
      this.columnIndex = column.index
      if (column.property != 'use') {
        this.$nextTick(() => {
          this.$refs['editInput'][0].focus()
        })
      }
    },
    // 只能有一把刀选中铣内外异形
    onlyOneChecked(event, row, key) {
      if (event.target.checked) {
        this.knives.forEach((v) => {
          v.knifePurpose = v.knifePurpose.filter((item) => item !== key)
        })
        row.knifePurpose.push(key)
      }
    },
    // scope.row, knife.props, knife.isCheck
    handleKnivesInputCheck(row, prop, flag) {
      // 刀具编号保留50个字符
      if (prop == 'knife_name') {
        row[prop] = row[prop].trim().slice(0, 50)
      }
      if (flag) {
        row[prop] = regReplaceCuttingDockInputCheck(row[prop])
      }
      // 刀径只能输入数字且不能为负数和0
      if (prop === 'diameter') {
        verifyInputNumber(row[prop], row, ['diameter'], '3-2', false, '')
      }
    },
    // 修改表格中的值
    inputBlur(row) {
      this.rowIndex = -1
      this.columnIndex = -1
      // 失去焦点判断刀直径是否为0
      if (row['diameter'] === 0) {
        row['diameter'] = ''
      }
      if (row['diameter']) {
        row['diameter'] = Number(row['diameter'])
      }
    },
    // 添加刀具
    handleAddNewKnife() {
      this.knives.push({
        idx: this.knives.length + 1,
        diameter: '',
        use: '',
        milling_outer: false,
        milling_inner: false,
        drilling: false,
        slotting: false,
        knife_name: '',
        knifePurpose: [],
        webId: genUniId(),
      })
      this.rowIndex = this.knives.length - 1
      this.columnIndex = 1
      this.$nextTick(() => {
        this.$refs['editInput'][0].focus()
      })
      // 序号处理
      this.knives = this.knives.map((item, index) => ({
        ...item,
        idx: index + 1,
      }))
    },
    // 删除刀具
    handleDeleteKnife() {
      if (this.knives.length < 2) {
        this.$message({
          message: '刀具不能少于1个',
          type: 'error',
        })
        return
      }
      this.knives.splice(
        this.knives.findIndex((v) => v.index == this.currentRow.index),
        1
      )
      // 序号处理
      this.knives = this.knives.map((item, index) => ({
        ...item,
        idx: index + 1,
      }))
    },

    handleClickContentContainer(e) {
      // 需要记录操作埋点的id
      const buryPOintIds = [
        'fiveSix_setting_internal_cut_inside_checkbox',
        'fiveSix_setting_externalCutting_checkbox',
        'fiveSix_setting_cut_path_extension_checkbox',
        'fiveSix_setting_cut_path_extension_radio_1',
        'fiveSix_setting_cut_path_extension_radio_2',
      ]
      const { target } = e
      const { id } = target
      if (buryPOintIds.includes(id)) {
        // 埋点
        buryPoint({ function_module: 'dock56f', function_point: id })
      }
    },
    // 获取设备使用权限
    async enableEngravingPermission(machineName) {
      let { edition_id } = store.state.userInfo
      const res = await getEquipmentPermission({
        process_id: this.$route.query.setting_id,
        machine: machineName,
        edition_id: edition_id,
        use_machine: 0,
      })
      if (res.status === 1) {
        return Boolean(res.data.can_use_num)
      }
      return false
    },
  },
  computed: {
    ...mapState('equipEnvironment', ['previewProductLine', 'previewInfo']),
    plankNameColumns() {
      return [
        {
          title: this.$translateLang('板件名'),
          dataIndex: 'plank_name',
          scopedSlots: { customRender: 'plankName' },
          width: 200,
          align: 'center',
        },
        {
          title: this.$translateLang('板件边'),
          dataIndex: 'plank_edge',
          scopedSlots: { customRender: 'plankEdge' },
          width: 160,
          align: 'center',
        },
        {
          title: this.$translateLang('固定在设备'),
          dataIndex: 'device_side',
          scopedSlots: { customRender: 'deviceSide' },
          width: 160,
          align: 'center',
        },
        {
          title: this.$translateLang('操作'),
          dataIndex: 'operation',
          width: 120,
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ]
    },
    showSixDockSpecial() {
      const fileType = ['ban', 'mpr'].includes(this.selectedDockFile)
      return (
        this.dockType == 'sixDock' && !this.dock56FDrill_customFile && fileType
      )
    },
    showFiveDockSpecial() {
      const fileType = ['xml2', 'mpr'].includes(this.selectedDockFile)
      return (
        this.dockType == 'fiveDock' && !this.dock56FDrill_customFile && fileType
      )
    },
    // 是否选中默认模板
    showFiveSixDefault() {
      return ['xml2', 'mpr', 'dxf', 'ban'].includes(this.selectedDockFile)
    },
  },
  async mounted() {
    this.sawPermission = await this.enableEngravingPermission('saw')
    this.handleGetLockStatus()
    if (this.$route.query.from) {
      if (this.$route.query.from == 'tiangong') {
        this.showTiangong = true
      }
    } else {
      this.showTiangong = false
      if (this.$route.query) {
        if (this.$route.query.setting_id) {
          this.getAllDock56File()
        }
      }
    }
    Navigate.getInstance().registerEvent(this.$route.path, {
      waitLoadDone: () => (this.ableSaveSetting ? 1 : 0),
    })
  },
  beforeDestroy() {
    Navigate.getInstance().unregisterEvent('/dockFiveSix')
  },
}
</script>

<style scoped lang="less">
/deep/.el-input {
  width: 50px;
}
.dock-five-six {
  .wrap {
    margin: 16px;
    overflow-y: auto;
    background: #fff;
    .equip-type {
      position: relative;
      .content {
        box-sizing: border-box;
        padding: 24px 24px 0 24px;
      }
      .content-level {
        padding-left: 50px;
      }
      .useCustomFileSet {
        position: absolute;
        top: 10px;
        right: 40px;
      }
      .toCustomFile {
        position: absolute;
        top: 10px;
        right: 20px;
        color: #18a8c7;
        cursor: pointer;
      }
    }
    .file-format {
      .content {
        box-sizing: border-box;
        padding: 24px 24px 0 24px;
        .ant-select {
          width: 190px;
        }
        .remark-info {
          .note {
            color: #f00;
          }
        }
      }
      .content-level {
        padding-left: 50px;
      }
      .not-online {
        margin-left: 16px;
        color: #f00;
        font-size: 14px;
      }
    }
    .common-setting {
      .content {
        padding: 24px 24px 0 24px;
        .ant-input {
          width: 80px;
        }
        .partition {
          margin-left: 15px;
        }
        .slot-tuglie {
          width: 380px;
        }
        .hintColor {
          color: #f00;
        }
        .check {
          margin: 0 20px 0 10px;
        }
        .drill-slot-dir {
          margin-left: 270px;
        }
        &.front-back-symbol {
          display: flex;
          align-items: center;
          > div {
            margin-right: 24px;
          }
          .ant-input {
            width: 192px;
          }
        }
        &.shape-texdir {
          .ant-radio-group .ant-radio-wrapper {
            margin-right: 85px;
          }
          .ant-radio-group .ant-radio-wrapper:first-child {
            margin-right: 0px;
          }
        }
        .fiveSix_externalCutting_checkbox {
          margin-right: 10px;
        }
      }
      .content-level {
        padding-left: 50px;
      }
      .add-row {
        width: 160px;
        color: #18a8c7;
        cursor: pointer;
        white-space: nowrap;
      }
      .plank-name-placement-del {
        color: #f00;
        cursor: pointer;
      }
      .plank-name-cell {
        min-height: 32px;
        line-height: 32px;
        padding: 0 11px;
        cursor: text;
        word-break: break-all;

        &.is-placeholder {
          color: rgba(0, 0, 0, 0.25);
        }
      }
      .slot-compensation-content {
        display: flex;
        align-items: baseline;
        .item {
          display: flex;
          align-items: center;
          margin-bottom: 15px;
          .item-input {
            width: 120px;
            margin: 0 10px;
          }
        }
      }
      .part-mark-content {
        display: flex;
        align-items: center;
        .item {
          display: flex;
          align-items: center;
          .item-input {
            width: 120px;
            margin: 0 10px;
          }
          &-tip {
            color: '#999';
          }
        }
      }
      .adjacent-size-transition-enter-active,
      .adjacent-size-transition-leave-active {
        transition: opacity 0.25s;
      }
      .adjacent-size-transition-enter,
      .adjacent-size-transition-leave-to {
        opacity: 0;
      }
      .main-table {
        display: flex;
        box-sizing: border-box;
        padding: 24px 5px 24px 24px;
        /deep/.el-table {
          flex: none;
          &::before {
            background: transparent;
          }
          .has-gutter tr {
            background-color: #fafafa;
          }
          .el-table__cell {
            text-align: center;
          }
          .el-table__cell.gutter {
            background-color: rgb(250, 250, 250);
          }
          .hidden-columns {
            display: none;
          }
          .knives_type {
            .icon-revise-show {
              display: none;
            }
            &:hover .icon-revise-show {
              display: inline-block;
            }
          }
          .ant-checkbox-wrapper + .ant-checkbox-wrapper {
            margin-left: 0;
          }
        }
        .knife-header {
          display: flex;
          flex-wrap: nowrap;
          align-items: center;
          span {
            margin: 0 2px;
            white-space: nowrap;
          }
        }
        .knives-tip {
          margin-left: 30px;
          color: rgba(0, 0, 0, 0.6);
          p {
            margin-bottom: 10px;
          }
        }
      }
      .operation-btn {
        padding: 10px 0 10px 24px;
        .danger-btn {
          color: #ff4d4f;
          &.ant-btn {
            border-color: #ff4d4f;
          }
        }
        .disabled-btn {
          opacity: 0.6;
        }
      }
    }
    .five-special-setting {
      .content {
        padding: 24px 24px 0 24px;
        > .small-title {
          margin-right: 16px;
        }
        .ant-input {
          width: 90px;
        }
        &.display {
          display: flex;
          align-items: center;
        }
        .tex-dir {
          margin-right: 16px;
        }
      }
    }
    .six-special-setting {
      .content {
        padding: 24px 24px 0 24px;
        .small-title {
          width: 220px;
        }
      }
    }
    .general-box {
      .content {
        padding: 24px 24px 0 24px;
        .small-title {
          width: 220px;
        }
      }
    }
  }
}
.tip {
  color: #f00;
}

.link {
  color: #18a8c7;
  cursor: pointer;
}
</style>

<style lang="scss">
.fixture-placement-tip {
  .ant-tooltip-inner {
    max-width: 360px;
    padding: 10px 12px;
    white-space: normal;
  }

  .fixture-placement-tip__content {
    line-height: 1.4;
    font-size: 12px;

    p {
      margin: 0 0 4px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .fixture-placement-tip__title {
    margin-bottom: 8px !important;
    font-weight: 600;
  }
}

.plank-name-placement-tip {
  .ant-tooltip-inner {
    max-width: 360px;
    padding: 10px 12px;
    background-color: #fff;
    white-space: normal;
  }

  .ant-tooltip-arrow::before {
    background-color: #fff;
  }

  .plank-name-placement-tip__content {
    line-height: 1.5;
    font-size: 14px;
    color: rgb(0, 0, 0, 0.65);

    p {
      margin: 0 0 6px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
